var React = require('react');

function IconLongHorizontalArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 15.5L239 15.5","stroke":"#FDFBF8","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M247.5 16L219.892 32L219.892 -1.20678e-06L247.5 16Z","fill":"#FDFBF8","key":1})]);
}

IconLongHorizontalArrow.defaultProps = {"width":"248","height":"32","viewBox":"0 0 248 32","fill":"none"};

module.exports = IconLongHorizontalArrow;

IconLongHorizontalArrow.default = IconLongHorizontalArrow;
